import {getCookie} from "./getCookie";
import {setCookie} from "./setCookie";

function checkListViewCookie() {

    if (getCookie('filter_view') == 0) {
        $('#list-view').addClass('active');
        $('#grid-view').removeClass('active');
        $('.product-item').removeClass('col-xs-6 col-md-4 col-lg-3 grid-view');
        $('.product-item').addClass('col-xs-12');
    }

    $(document).on('click', '#grid-view', function(){
        $(this).addClass('active');
        $('#list-view').removeClass('active');
        $('.product-item').addClass('col-xs-6 col-md-4 col-lg-3 grid-view');
        $('.product-item').removeClass('col-xs-12');
        setCookie('filter_view', 1);
    });

    $(document).on('click', '#list-view', function(){
        $(this).addClass('active');
        $('#grid-view').removeClass('active');
        $('.product-item').removeClass('col-xs-6 col-md-4 col-lg-3 grid-view');
        $('.product-item').addClass('col-xs-12');
        setCookie('filter_view', 0);
    });
}

export {checkListViewCookie}